import React from 'react'
import CurrentAppointment from '../../../components/CurrentAppointment/CurrentAppointment'

function Current() {
  return (
    <CurrentAppointment />
  )
}

export default Current